module.exports = __webpack_public_path__ + "files/f0352a98742d340524e3d801cc4fc4e0.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-italic-webfont.svg
 ** module id = 890
 ** module chunks = 0
 **/